<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>{{user.firstname + ' ' + user.lastname}}</h2> -->
        <TabNav :links="routesNav" @action="onNavAction" />
    </div>

    <div class="container-body">
        <div class="info-grid">

            <section class="info-card">
                <h3 class="info-card__title">Información personal</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Nombre</dt>
                        <dd>{{ fullName }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Correo</dt>
                        <dd>{{ user.username || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Login</dt>
                        <dd>{{ user.login || 'No posee login' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Región</dt>
                        <dd>{{ user.region || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Cargo</dt>
                        <dd>{{ user.cargo || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Teléfono</dt>
                        <dd>{{ user.telefono || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Género</dt>
                        <dd>{{ user.genero || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Tipo de usuario</dt>
                        <dd>{{ user.es_externo ? 'Externo' : 'Interno' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Institución</dt>
                        <dd>{{ user.institucion || '—' }}</dd>
                    </div>
                </dl>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">Cuenta</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Fecha creación</dt>
                        <dd>{{ dateFormatter(user.created_at) }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Último login</dt>
                        <dd>{{ dateTimeFormatter(user.last_login) }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Estado</dt>
                        <dd>
                            <span class="badge" :class="user.status === false ? 'badge--off' : 'badge--on'">
                                {{ user.status === false ? 'Inactiva' : 'Activa' }}
                            </span>
                        </dd>
                    </div>
                    <!-- El estado de la contraseña va en su propia fila: es otra cosa
                         que el estado de la cuenta, y apilar los dos distintivos en la
                         misma celda partía el texto largo por la mitad. -->
                    <div class="info-card__row">
                        <dt>Contraseña</dt>
                        <dd>
                            <!-- Solo el estado temporal lleva distintivo: es el que pide
                                 acción. El caso normal va como texto, que además puede
                                 fluir a dos líneas sin romperse en esta columna. -->
                            <template v-if="user.es_clave_temporal">
                                <span class="badge badge--temp">Temporal</span>
                                <span class="password-hint">Debe cambiarla al iniciar sesión.</span>
                            </template>
                            <template v-else>Definida por el usuario</template>
                        </dd>
                    </div>
                </dl>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">Permisos</h3>
                <!--Cambiar nombres segun observacion de SENAPRED 06/2026 ("1. En la creación y en la edición, el nombre de los permisos debe ser el mismo que aparece en ver usuarios.")-->
                <!--Se elimina geoprocesos porque la vista asociada esta deshabilitada (revision SENAPRED 06/2026)-->
                <div class="chip-row">
                    <span
                    v-for="perm in permissionItems"
                    :key="perm.label"
                    class="chip"
                    :class="perm.granted ? 'chip--on' : 'chip--off'"
                    >
                        <font-awesome-icon v-if="perm.granted" icon="check" class="chip__icon"></font-awesome-icon>
                        {{ perm.label }}
                    </span>
                </div>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Grupos
                    <span v-if="userGroups.length" class="maps-count">{{ userGroups.length }}</span>
                </h3>
                <p v-if="!userGroups.length" class="maps-empty">Sin grupos asignados</p>
                <div v-else class="chip-row">
                    <span v-for="group in userGroups" :key="group.id" class="chip chip--tag">
                        <font-awesome-icon icon="users" class="chip__icon"></font-awesome-icon>
                        {{ group.name }}
                    </span>
                </div>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Mapas asignados al usuario
                    <span v-if="userMaps.length" class="maps-count">{{ userMaps.length }}</span>
                </h3>
                <p v-if="!userMaps.length" class="maps-empty">Sin mapas asignados</p>
                <ul v-else class="maps-list">
                    <li v-for="item in calculateAssignedMapsPage" :key="item.id">
                        <router-link class="maps-list__item" :to="'/mapas/' + item.id">
                            <font-awesome-icon icon="map" class="maps-list__icon"></font-awesome-icon>
                            <span class="maps-list__name">{{ item.name }}</span>
                            <span v-if="item.group" class="maps-list__via">vía grupo: {{ item.group.name }}</span>
                            <span class="maps-list__go" aria-hidden="true">›</span>
                        </router-link>
                    </li>
                </ul>

                <Pagination
                v-show="totalPages!=0"
                v-bind:totalPages="totalPages"
                v-bind:currentPage="currentPage"
                v-bind:pageSize="pageSize"
                v-on:pagechanged="pageChangedClick"
                >
                </Pagination>
            </section>

        </div>

        <span v-if="!logs">No hay acciones que mostrar</span>
    </div>

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

    <UserDeleteModal
      v-if="showDeleteModal"
      :userId="$route.params.idUser"
      :userName="deleteModalUserName"
      @close="closeDeleteModal"
      @deleted="onUserDeleted"
    />

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import LogItem from '@/components/LogItem.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restUser} from '@/components/mixin/restUser.js'
import { userDeleteModal } from '@/components/mixin/userDeleteModal.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restUser, userDeleteModal],
    data(){
        return{
            userGroups: [],
            logs: [],
            groups: [],
            assignedMaps: [],
            inheritedMaps: []
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        LogItem,
        TabNav
    },
    computed: {
        routesNav: function(){
          return [
                {name:'Resumen' , path: '/usuarios/' + this.$route.params.idUser, exact: true},
                {name:'Editar usuario' , path: '/usuarios/' + this.$route.params.idUser + '/editar-usuario'},
                {name:'Asignar mapas' , path: '/usuarios/' + this.$route.params.idUser + '/asignar-mapas'},
                {name:'Crear contraseña temporal' , path: '/usuarios/' + this.$route.params.idUser + '/contrasena-temporal'},
                {name:'Historial de cambios' , path: '/usuarios/' + this.$route.params.idUser + '/historial-de-cambios'},
                {name:'Eliminar usuario' , action: 'delete'}
              ]
        },
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: this.user.firstname + ' ' + this.user.lastname}
              ]
        },
        fullName: function(){
            var name = ((this.user.firstname || '') + ' ' + (this.user.lastname || '')).trim();
            return name.length ? name : '—';
        },
        permissionItems: function(){
            var permissions = this.user.permissions || {};
            var terrain = permissions.terrain || {};
            return [
                {label: 'Administración de usuarios', granted: !!permissions.users},
                {label: 'Administración de capas', granted: !!permissions.layers},
                {label: 'Administración de mapas', granted: !!permissions.maps},
                {label: 'Acceso al visor', granted: !!permissions.visor},
                {label: 'Acceso al monitoreo', granted: !!permissions.monitoring},
                {label: 'Administración de instructivos', granted: !!permissions.wiki},
                {label: 'Gestión de terreno', granted: !!terrain.manage},
                {label: 'Respuesta de terreno', granted: !!terrain.respond},
                {label: 'Revisión de terreno', granted: !!terrain.review},
                {label: 'Publicación de terreno', granted: !!terrain.publish},
            ];
        },
        // Los mapas que el usuario ve: los asignados directo más los que le dan sus grupos.
        // Si un mapa llega por las dos vías se lista una sola vez y cuenta como directo,
        // porque el directo es el que se puede modificar desde "Asignar mapas".
        userMaps: function (){
            var direct = this.assignedMaps || [];
            var directIds = direct.map(function(item){ return item.id; });
            var inherited = (this.inheritedMaps || []).filter(function(item){
                return directIds.indexOf(item.id) === -1;
            });
            return direct.concat(inherited);
        },
        calculateAssignedMapsPage: function (){

            let maps = this.userMaps;

            let pageResults = [];

            let skip = this.currentPage > 0 ? ( ( this.currentPage - 1 ) * this.pageSize ) : 0 ;
            for (let i = skip; i < maps.length && i < skip + this.pageSize ; i++) {
                pageResults.push(maps[i])
            }

            //Calcula total de páginas
            if(maps.length <= this.pageSize) {
                this.totalPages = 0;
                return pageResults;
            }
            if ( maps.length % this.pageSize > 0 ) {
                this.totalPages =  Math.floor( (maps.length / this.pageSize) + 1 )
                return pageResults;
            } else {
                this.totalPages = Math.floor( (maps.length / this.pageSize) )
                return pageResults;
            }
        },
    },
    props: [],
    methods:{
        pageChangedClick: function (page){
            this.currentPage = page;
            this.getUserLogs(this.currentPage);
        },
        getGroupByID: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/groups')
            .then(function (response) {
                that.userGroups = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getUserLogs: function(page) {
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/logs?page=' + page)
            .then(function (response) {
                that.logs = response.data;
                response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedMaps: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/maps') //Sin paginación
            .then(function (response) {
                that.assignedMaps = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getInheritedMaps: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/maps/inherited') //Sin paginación
            .then(function (response) {
                that.inheritedMaps = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        }
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getUser();
        this.getAssignedMaps()
        this.getInheritedMaps()
    },
    watch: {
        'user': function (newValue, oldValue) {
            if(newValue.id_groups && newValue.id_groups.length){
                this.getGroupByID();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
// Los estilos del sistema info-card/chips/maps-list viven en assets/style/style.scss

// Variante de aviso del sistema .badge (definido en style.scss junto a
// --on/--off), para el estado "contraseña temporal".
.badge--temp {
    padding: 0.15rem 0.65rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.5;
    background: #fdf3df;
    color: var(--color-warning);
    // La píldora nunca debe partirse en dos líneas: el fondo redondeado se corta.
    white-space: nowrap;
}

.password-hint {
    display: block;
    margin-top: 0.3rem;
    font-size: 0.78rem;
    color: var(--color-ghost);
}

</style>
